<template>
    <module-templates
        v-if="moduleInfoIsSet"
        :service="service()"
        @selected="selectionChanged"
    />
</template>

<script>
import * as FilterGroupService from "../../services/FilterGroupService"

import {mapState, mapActions} from 'pinia';
import {useMainStore} from '../../state/store';
import {useNotificationsStore} from '../../state/modules/notifications';

import ModuleTemplates from "./ModuleTemplates.vue";
import {ADD_NOTIFICATION} from '../../state/mutation-types';

export default {
    name: "FilterGroups",
    components: {ModuleTemplates},
    data: function () {
        return {
            moduleInfoIsSet: false,
            group: null,
            saving: false,
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
    },
    methods: {
        ...mapActions(useMainStore, ['setTemplateModuleInfo']),
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        service() {
            return FilterGroupService;
        },
        setModuleInfo() {
            this.setTemplateModuleInfo({
                templateModel: 'filter-groups',
                model: 'filters',
                type: 'filter',
                children: 'filters',
                autocomplete: true,
                pivot: '',
                hasPivot: true,
                deleteItemConfirmation: true,
                pivot_id: 'filter_id',
                allowDuplicate: false,
                title: {
                    attribute: 'title',
                    locale: this.locale
                },
                text: {
                    title: this.$t('settings.filter-groups.title'),
                    sub_title: this.$t('settings.filter-groups.your_filters'),
                    new_item: this.$t('settings.filter-groups.new_filter'),
                    item_short: 'F',
                    no_items_found: this.$t('settings.filter-groups.no_filters'),
                    new_template_placeholder: this.$t('settings.filter-groups.template_name'),
                    tooltip: this.$t('settings.filter-groups.tooltip'),
                },
            });

            this.moduleInfoIsSet = true
        },
        async selectionChanged(group) {
            this.group = group;
        }
    },
    mounted() {
        this.setModuleInfo();
    }
}
</script>
